<template>
    <div
        id="app"
        :class="[
            animateClass,
            {
                'animate-none': disable_transitions,
                'animate-reverse' : animateReverse,
            }
        ]"
    >

        <HeaderComp
            :headerReverse="headerReverse"
            :stepCurrent="step()"
        />

        <div class="main-content bg-textured fh--pb">
            <transition
                name="view-load"

                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:after-enter="afterEnter"

                v-on:before-leave="beforeLeave"
                v-on:leave="leave"
                v-on:after-leave="afterLeave"
            >
                <router-view
                    @emit-header-reverse="updateHeaderReverse"
                />
            </transition>
        </div>

        <svg class="background-bike" width="487" height="258" viewBox="0 0 487 258" xmlns="http://www.w3.org/2000/svg"><g fill="#414142" fill-rule="nonzero"><path d="M170.578 254.52c-21.297.002-40.499-12.824-48.65-32.5a52.654 52.654 0 11101.298-20.155c-.03 29.065-23.583 52.621-52.648 52.656m-.007-96.452c-24.188.003-43.794 19.614-43.792 43.802.002 24.188 19.613 43.795 43.8 43.793 24.189-.002 43.796-19.61 43.795-43.799-.03-24.178-19.625-43.77-43.803-43.796"/><path d="M170.576 216.898a15.032 15.032 0 1115.028-15.03c-.008 8.297-6.731 15.022-15.028 15.03m-.002-21.208a6.175 6.175 0 106.18 6.179 6.187 6.187 0 00-6.179-6.178M318.346 254.51a52.654 52.654 0 1152.648-52.656c-.03 29.066-23.582 52.621-52.648 52.656m-.007-96.452c-24.188.004-43.793 19.614-43.791 43.802.001 24.188 19.612 43.795 43.8 43.793 24.188-.001 43.796-19.61 43.795-43.798-.03-24.179-19.625-43.771-43.804-43.797"/><path d="M318.342 216.888a15.032 15.032 0 1115.03-15.03c-.008 8.297-6.732 15.022-15.03 15.03m-.001-21.209a6.175 6.175 0 106.179 6.18 6.186 6.186 0 00-6.178-6.179M229.65 208.33l-47.507.004a4.428 4.428 0 010-8.856l47.506-.004a4.428 4.428 0 11.001 8.857M254.702 196.128a4.427 4.427 0 01-3.902-6.518l27.428-51.246-70.684.005-30.14 55.295a4.428 4.428 0 11-7.775-4.242l31.397-57.603a4.43 4.43 0 013.886-2.301l80.705-.006a4.423 4.423 0 013.902 6.513l-30.91 57.765a4.43 4.43 0 01-3.902 2.338"/><path d="M237.953 194.83a4.43 4.43 0 01-3.783-2.12l-45.563-74.514a4.429 4.429 0 017.554-4.619l45.565 74.513a4.43 4.43 0 01-3.773 6.74"/><path d="M208.333 117.87l-34.009.002a4.428 4.428 0 010-8.856l34.008-.003a4.428 4.428 0 01.001 8.857M314.747 195.798a4.42 4.42 0 01-4.075-2.701l-34.177-80.532a4.427 4.427 0 014.076-6.16l28.634-.002c7.76 0 16.007 5.081 16.732 14.805.5 6.66-3.396 14.496-13.136 15.97a4.429 4.429 0 01-1.328-8.757c4.469-.676 5.837-3.826 5.635-6.552-.25-3.288-2.788-6.608-7.904-6.607l-21.943.001 31.562 74.373a4.434 4.434 0 01-4.077 6.16M244.404 219.616c-9.614 0-17.408-7.792-17.408-17.406-.001-9.613 7.792-17.407 17.405-17.408 9.614 0 17.408 7.792 17.409 17.406-.01 9.61-7.797 17.397-17.406 17.408m-.002-25.96a8.551 8.551 0 108.553 8.553 8.561 8.561 0 00-8.553-8.55"/><path d="M244.802 192.388a4.442 4.442 0 01-4.308-5.47l2.663-10.986a4.428 4.428 0 118.604 2.087l-2.661 10.982a4.427 4.427 0 01-4.302 3.386"/><path d="M252.95 177.41h-9.65a4.428 4.428 0 01-.001-8.856h9.65a4.428 4.428 0 010 8.856M240.478 231.323a4.49 4.49 0 01-1.05-.132 4.424 4.424 0 01-3.26-5.342l2.665-10.982a4.428 4.428 0 018.604 2.087l-2.661 10.982a4.427 4.427 0 01-4.302 3.386"/><path d="M244.636 235.32h-9.65a4.428 4.428 0 010-8.856l9.65-.001a4.428 4.428 0 010 8.857"/><g><path d="M63.953 207.706l29.283-.002a4.392 4.392 0 010 8.784l-29.283.002c-5.656.007-10.24 4.593-10.244 10.25a7.327 7.327 0 007.318 7.318A4.982 4.982 0 0066 229.081a4.392 4.392 0 118.784-.001c-.007 7.596-6.162 13.753-13.758 13.763-8.888-.01-16.091-7.214-16.101-16.103.01-10.505 8.522-19.02 19.027-19.034zM23.61 146.221c10.47.011 18.955 8.495 18.968 18.966-.012 8.858-7.19 16.037-16.05 16.048a4.392 4.392 0 010-8.783 7.276 7.276 0 007.267-7.269c-.009-5.62-4.565-10.173-10.185-10.178-7.632.01-13.816 6.194-13.825 13.826.015 10.147 8.237 18.368 18.383 18.381l65.066-.004a4.392 4.392 0 010 8.783l-65.065.005c-14.996-.016-27.15-12.168-27.167-27.164.014-12.48 10.127-22.595 22.607-22.61z"/></g><g stroke="#000" stroke-opacity="0"><path d="M198.784 67.432c-.302-.271-.626-.533-.937-.785a11.178 11.178 0 01-1.901-1.798c-5.823-7.6-11.97-15.698-19.937-26.259a6.317 6.317 0 01-1.27-5.872 5.792 5.792 0 014.324-3.553 5.226 5.226 0 013.104.095 5.254 5.254 0 012.376 1.823A5367.93 5367.93 0 01205.1 58.207c1.575 2.09 1.85 4.108.816 5.996a5.66 5.66 0 01-5.328 3.335 6.219 6.219 0 01-1.111-.166 13.856 13.856 0 00-.515-.102l-.112.1-.017.015-.053.047h.003zm45.5-5.256l-.111-.04a5.426 5.426 0 01-3.778-5.683c.297-14.388.642-31.11.991-47.494a6.79 6.79 0 011.345-3.99 5.626 5.626 0 013.297-2.148 5.415 5.415 0 013.02.225 6.374 6.374 0 012.873 2.13 5.429 5.429 0 011.143 3.378c-.122 7.01-.256 14.104-.388 20.963v.026c-.167 8.804-.341 17.907-.486 26.865a6.09 6.09 0 01-2.676 4.969 5.794 5.794 0 01-5.23.798zm45.809 8.84l-.005-.002a5.918 5.918 0 01-3.548-4.041 6.103 6.103 0 011.326-5.625l7.589-9.065.25-.298.522-.624 7.37-8.803 1.62-1.943.002-.009c1.255-1.508 2.552-3.068 3.86-4.574a6.239 6.239 0 016.48-1.522l.082.03a4.82 4.82 0 012.36 1.971c.59.968.902 2.079.903 3.211a6.245 6.245 0 01-1.63 4.203 7674.332 7674.332 0 00-15.734 18.79 623.877 623.877 0 00-4.26 5.175l-.013.015-1.512 1.849a4.388 4.388 0 01-2.485 1.461 5.87 5.87 0 01-3.176-.198h-.001z" stroke="none"/></g></g></svg>

        <ProgressBar
            :stepCurrent="step()"
            :stepPopulated="stepPopulated()"
            :steps="[
                {
                    index: 1,
                    title: tr('Location'),
                    icon: 'progress_bar/location',
                    location: '/location',
                },
                {
                    index: 2,
                    title: tr('Room Type'),
                    icon: 'progress_bar/room_type',
                    location: '/room-type',
                },
                {
                    index: 3,
                    title: tr('Booking Details'),
                    icon: 'progress_bar/booking_details',
                    location: '/booking-details',
                },
                {
                    index: 4,
                    title: tr('Personal Details'),
                    icon: 'progress_bar/personal_details',
                    location: '/personal-details',
                },
                {
                    index: 5,
                    title: tr('Payment'),
                    icon: 'progress_bar/payment',
                    location: '/payment',
                },
                {
                    index: 6,
                    title: tr('Finished'),
                    icon: 'progress_bar/finished',
                    location: '/finished',
                },
            ]"
        />

        <FooterComp />

    </div>
</template>

<script>
import Vue from 'vue';

// components
import HeaderComp from '@/components/HeaderComp.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import FooterComp from '@/components/FooterComp.vue';

export default Vue.extend({
    components: {
        HeaderComp,
        ProgressBar,
        FooterComp,
    },
    data() {
        return {
            headerReverse: 'no',
            animateClass: '',
            animateReverse: false,
        }
    },
    methods: {
        step() {
            switch (this.$router.currentRoute.path) {
                default: return 0;
                case "/location": return 1;
                case "/room-type": return 2;
                case "/booking-details": return 3;
                case "/personal-details": return 4;
                case "/payment": return 5;
                case "/complete": return 6;
            }
        },
        stepPopulated() {
            if (this.$store.getters.isComplete) {
                return 6;
            }
            if (this.$store.getters.isPersonalComplete) {
                return 5;
            }
            if (this.$store.getters.isBookingComplete) {
                return 4;
            }
            if (this.$store.getters.isRoomValid) {
                return 3;
            }
            if (this.$store.getters.isLocationValid) {
                return 2;
            }
            return 1;
        },
        updateHeaderReverse(headerValue) {
            this.headerReverse = headerValue;
        },
        beforeEnter() {
            this.animateClass = 'animate_before-enter'
        },
        enter() {
            this.animateClass = 'animate_enter'
        },
        afterEnter() {
            this.animateClass = 'animate_after-enter'
        },
        beforeLeave() {
            this.animateClass = 'animate_before-leave'
        },
        leave() {
            this.animateClass = 'animate_leave'
        },
        afterLeave() {
            this.animateClass = 'animate_after-leave'
        }
    },
    computed: {
        disable_transitions() {
            return this.$store.state.disable_transitions;
        }
    },
});
</script>

<style>
@import '~@/assets/css/flexboxgrid.css';

:root {
    --bg-color: #FEF200;
    --accent-font: 'Bree Serif', 'Roboto', 'Noto Sans JP', 'Noto Sans SC', sans-serif;
}

/* TODO Install postcss/autoprefixer. */
@-webkit-viewport {
    width: device-width;
    zoom: 1;
}
@-moz-viewport {
    width: device-width;
    zoom: 1;
}
@-ms-viewport {
    width: device-width;
    zoom: 1;
}
@-o-viewport {
    width: device-width;
    zoom: 1;
}
@viewport {
    width: device-width;
    zoom: 1;
}

/* ------------------------------------------------------
**** Box Model Reset
------------------------------------------------------ */

html {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 15px;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-text-size-adjust: 100%;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    background-color: #eceef3;
}

* {
    background-repeat: no-repeat;
    padding: 0;
    margin: 0;
}

*,
*:before,
*:after {
    -webkit-box-sizing: inherit;
    box-sizing: inherit;
}

/* ------------------------------------------------------
**** Typography
------------------------------------------------------ */

html {
    font-size: 62.5%;
}

body {
    font-size: 1.5rem;
    line-height: 1.75;
    color: #414142;
    background-color: #eceef3;
    font-family: 'Roboto', 'Noto Sans JP', 'Noto Sans SC', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
}

/* fonts */
@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&family=Roboto:wght@400;700&family=Noto+Sans+JP:wght@400;700&family=Noto+Sans+SC:wght@400;700&display=swap');


/* ------------------------------------------------------
**** Text Elements Spacing
------------------------------------------------------ */
p + p,
p + ul,
p + ol,
p + dl,
p + blockquote,
p + address {
    margin-top: 2rem;
}

/* ------------------------------------------------------
**** Headings
------------------------------------------------------ */
h1, .h1 {
    font-size: 28px;
    font-family: var(--accent-font);
    line-height: 1.2;
    font-weight: 400;
    margin-bottom: 3rem;
}

h2, .h2 {
    font-size: 24px;
    font-family: var(--accent-font);
    line-height: 1.2;
    font-weight: 400;
}

h3, .h3 {
    font-size: 21px;
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    line-height: 1.75;
}

h4, .h4 {
    font-size: 18px;
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    line-height: 1.75;
}

h5, .h5 {
    font-size: 16px;
    font-family: var(--accent-font);
    font-weight: 400;
    line-height: 1.75;
}

.markdown h3, .markdown .h3,
.markdown h4, .markdown .h4,
.markdown h5, .markdown .h5 {
    font-family: var(--accent-font);
    line-height: 1.2;
    font-weight: 400;
}


/* BP Smaller */
@media screen and (min-width: 35em) { /* 560px */
    h1, .h1 {
        font-size: 40px;
    }

    h2, .h2 {
        font-size: 35px;
    }

    h3, .h3 {
        font-size: 28px;
    }

    h4, .h4 {
        font-size: 21px;
    }

    h5, .h5 {
        font-size: 18px;
    }
}

@media only screen and (min-width: 62em) { /* 992px */
    h1, .h1 {
        font-size: 56px;
    }
}

.h-sm {
    font-size: 0.8em;
}

.h-underline {
    border-bottom: 3px solid #414142;
}

strong,
b {
    font-weight: 700;
}

/* Text helper classes */
.txt-subtle {
    font-size: 1.2rem;
}

.txt-ttc {
    text-transform:capitalize;
}

.txt-ttl {
    text-transform: lowercase !important;
}

.txt-accent-01 {
    color: #FEF200;
}

.txt-accent-02 {
    color: #BF1E2E;
}

/* BP Smaller */
@media screen and (min-width: 35em) { /* 560px */
    .txt-special {
        font-size: 1.8rem;
    }
}

@media only screen and (min-width: 62em) { /* 992px */
    .txt-special {
        font-size: 2.1rem;
        font-weight: 700;
    }
}

/* ------------------------------------------------------
**** Backgrounds
------------------------------------------------------ */

/* .bg-textured {
    position: relative;
    z-index: 1;
}

.bg-textured:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: -1;
    background: -o-linear-gradient(315deg, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.05) 25%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.05) 75%, rgba(0, 0, 0, 0.05) 100%);
    background: linear-gradient(135deg, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.05) 25%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.05) 75%, rgba(0, 0, 0, 0.05) 100%);
    background-size: 8.49px 8.49px;
} */

.bg-textured {
    background: -o-linear-gradient(315deg, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.05) 25%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.05) 75%, rgba(0, 0, 0, 0.05) 100%);
    background: linear-gradient(135deg, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.05) 25%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.05) 75%, rgba(0, 0, 0, 0.05) 100%);
    background-size: 8.49px 8.49px;
}

/* ------------------------------------------------------
**** Tick list
------------------------------------------------------ */
p + .tick-list {
    margin-top: 5px;
}

.tick-list {
    list-style-type: none;
    padding-left: 0;
    margin-bottom: 1.5rem;
}

.tick-list li {
    background-image: url(~@/assets/images/ico_tick.svg);
    background-repeat: no-repeat;
    background-position: center left 5px;
    background-size: 15px 15px;
    padding-left: 30px;
}



/* ------------------------------------------------------
**** Markdown
------------------------------------------------------ */
.markdown p + p {
    margin-top: 1.5rem;
}

.markdown h1,
.markdown h2,
.markdown h3,
.markdown h4,
.markdown h5 {
    margin-top: 3rem;
    margin-bottom: 1rem;
}

.markdown > *:first-child {
    margin-top: 0;
}

.markdown > *:last-child {
    margin-bottom: 0;
}

.markdown p + ul {
    margin-top: 5px;
}

.markdown ul {
    list-style-type: none;
    padding-left: 0;
    margin-bottom: 1.5rem;
}

.markdown li {
    background-image: url(~@/assets/images/ico_tick.svg);
    background-repeat: no-repeat;
    background-position: center left 5px;
    background-size: 15px 15px;
    padding-left: 30px;
}

.modal-body > .markdown {
    padding: 40px 20px;
}

@media screen and (min-width: 35em) { /* 560px */
    .modal-body > .markdown {
        padding: 40px 48px;
    }
}


.modal-body--padding {
    padding: 40px 20px;
}

@media screen and (min-width: 35em) { /* 560px */
    .modal-body--padding {
        padding: 40px 48px;
    }
}



/* buttons */
@import '~@/assets/css/atoms/buttons.css';

/* ------------------------------------------------------
**** Layout
------------------------------------------------------ */
#app {
    background-color: #FEF200;
    background-color: var(--bg-color);
    color: #414142;
    min-height: 100vh;
    width: 100vw;
    overflow: hidden;
}

.background-bike {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 80vw;
    -webkit-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
    z-index: -1;
}

.progress-sticky .background-bike {
    top: calc(50% - 25px);
}

@media screen and (min-width: 35em) { /* 560px */
    .progress-sticky .background-bike {
        top: calc(50% - 50px);
    }
}

.animate_enter .main-content,
.animate_leave .main-content {
    position: relative;
}

/* ------------------------------------------------------
**** Split Layout
------------------------------------------------------ */
.split-layout {
    background-color: #FEF200;
    background-color: var(--bg-color);
    color: #414142;
}

.split-layout__content {
    width: 100%;
    max-width: 100%;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 25px;
    padding-right: 25px;
}

.split-layout__content--wide {
    width: 100%;
    padding: 0;
}

@media only screen and (min-width: 48em) { /* 768px */
    .split-layout__content {
        max-width: 540px;
    }

    .split-layout__content--wide {
        width: 100%;
        padding: 0;
        max-width: unset;
    }
}

@media only screen and (min-width: 80em) { /* 1280px */
    .split-layout__content {
        padding-left: 0;
        padding-right: 0;
    }
}


/* ------------------------------------------------------
**** Layout / spacing
------------------------------------------------------ */
/* Helper classes */

/* ---- Padding ---- */
.pt-40-xs {
    padding-top: 40px;
}

.pt-80-xs {
    padding-top: 80px;
}

@media only screen and (min-width: 48em) { /* 768px */
    .pt-80-sm {
        padding-top: 80px;
    }
}


/* fill height */
/* screen height */
.fh-100 {
    min-height: 100vh;
}

/* screen height less progress bar (and header on mob) */
.fh--pb {
    min-height: calc(100vh - 125px);
}

/* BP Smaller */
@media screen and (min-width: 35em) {
    .fh--pb {
        min-height: calc(100vh - 162px);
    }
}

@media only screen and (min-width: 48em) { /* 768px */
    .fh--pb {
        min-height: calc(100vh - 102px);
    }
}

/* ---- Sections ---- */
.section {
    margin-bottom: 25px;
    margin-top: 25px;
}

/* BP Smaller */
@media screen and (min-width: 35em) { /* 560px */
    .section {
        margin-bottom: 40px;
        margin-top: 40px;
    }
}

@media only screen and (min-width: 62em) { /* 992px */
    .section {
        margin-bottom: 80px;
        margin-top: 80px;
    }
}

/* ------------------------------------------------------
**** Transitions
------------------------------------------------------ */
.view-load-enter-active,
.view-load-leave-active {
    transition: all 800ms ease;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.view-load-enter {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
}

.view-load-enter-to {
    -webkit-transform: translateX(0);
    transform: translateX(0);
}

.view-load-leave {
    -webkit-transform: translateX(0);
    transform: translateX(0);
}

.view-load-leave-to {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
}

.animate-none,
.animate-none .view-load-enter-active,
.animate-none .view-load-leave-active {
    transition: none !important;
}

/* ------------------------------------------------------
**** Google Map styles
------------------------------------------------------ */
.gm-style.gm-style-iw-c {
    border-radius:0;
    padding: 24px 22px;
}

.gm-style img[src^="/book/img/mm"] {
    -webkit-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
    transform-origin: 50% 100%;
    -webkit-transform-origin: 50% 100%;
    -moz-transform-origin: 50% 100%;
    -o-transform-origin: 50% 100%;
    -ms-transform-origin: 50% 100%;
}

.gm-style img[src^="/book/img/mm"][style*="opacity: 0.9"] {
    transform: scale(0.66);
    opacity: 1 !important;
}

.gm-style img[src^="/book/img/mm"][style*="opacity: 1"] {
    transform: scale(1);
}

@media only screen and (min-width: 48em) { /* 768px */
    .gm-style .gm-fullscreen-control {
        top: 50px !important;
        left: 0 !important;
        right: auto !important;
    }

    .gm-style .gm-style-mtc div {
        padding: 0px 10px !important;
    }

    .progress-sticky .gm-style .gm-bundled-control {
        position: fixed !important;
        bottom: 256px !important;
    }
}

@media only screen and (min-width: 62em) { /* 992px */
    .gm-style .gm-style-mtc div {
        padding: 0px 23px !important;
    }


    .gm-style .gm-fullscreen-control {
        top: 60px !important;
    }
}

.btn-outline svg.dark g {
    stroke: #414142;
    transition: all 200ms ease;
    -webkit-transition: all 200ms ease;
}

.btn-outline svg.dark path[stroke-width=".5"] {
    fill: #414142;
}

.btn-outline:hover svg.dark g,
.btn-outline:focus svg.dark g {
    stroke: #fff;
}

.btn-outline:hover svg.dark path[stroke-width=".5"],
.btn-outline:focus svg.dark path[stroke-width=".5"] {
    fill: #fff;
}

</style>
